import Mobile from './Mobile'

export default Mobile
